/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TriviaQuestion } from './TriviaQuestion';
import {
    TriviaQuestionFromJSON,
    TriviaQuestionFromJSONTyped,
    TriviaQuestionToJSON,
    TriviaQuestionToJSONTyped,
} from './TriviaQuestion';

/**
 * Trivia ad format configuration
 * @export
 * @interface TriviaConfig
 */
export interface TriviaConfig {
    /**
     * 
     * @type {Array<TriviaQuestion>}
     * @memberof TriviaConfig
     */
    questions: Array<TriviaQuestion>;
    /**
     * 
     * @type {number}
     * @memberof TriviaConfig
     */
    passingScore?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TriviaConfig
     */
    shuffleQuestions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TriviaConfig
     */
    shuffleOptions?: boolean;
}

/**
 * Check if a given object implements the TriviaConfig interface.
 */
export function instanceOfTriviaConfig(value: object): value is TriviaConfig {
    if (!('questions' in value) || value['questions'] === undefined) return false;
    return true;
}

export function TriviaConfigFromJSON(json: any): TriviaConfig {
    return TriviaConfigFromJSONTyped(json, false);
}

export function TriviaConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriviaConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'questions': ((json['questions'] as Array<any>).map(TriviaQuestionFromJSON)),
        'passingScore': json['passingScore'] == null ? undefined : json['passingScore'],
        'shuffleQuestions': json['shuffleQuestions'] == null ? undefined : json['shuffleQuestions'],
        'shuffleOptions': json['shuffleOptions'] == null ? undefined : json['shuffleOptions'],
    };
}

export function TriviaConfigToJSON(json: any): TriviaConfig {
    return TriviaConfigToJSONTyped(json, false);
}

export function TriviaConfigToJSONTyped(value?: TriviaConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questions': ((value['questions'] as Array<any>).map(TriviaQuestionToJSON)),
        'passingScore': value['passingScore'],
        'shuffleQuestions': value['shuffleQuestions'],
        'shuffleOptions': value['shuffleOptions'],
    };
}

